import { createActionGroup, emptyProps, props } from '@ngrx/store';
import { BookProgressResponseDto } from './book-progress.model';

export const BookProgressActions = createActionGroup({
  source: 'BookProgress API',
  events: {
    'Get Book Progress': emptyProps(),
    'Get Book Progress Success': props<{
      bookProgressResponse: BookProgressResponseDto;
    }>(),
    'Get Book Progress Failure': props<{ error: Error }>(),
    'Update Book Progress Success': props<{
      bookProgressResponse: BookProgressResponseDto;
    }>(),
    'Update Book Progress Failure': props<{ error: Error }>(),
  },
});
